/**
 * Portal features a build can hide, from VITE_HIDDEN_FEATURES: a comma-separated list
 * (e.g. "home,paci" in .env.brokerage). Empty / unset = everything shown.
 *  - home: no Home page or sidebar link; "/" opens the user's first menu item instead
 *  - paci: no PACI health pill in the top bar
 */
export type PortalFeature = "home" | "paci";

const hidden = new Set(
    `${import.meta.env.VITE_HIDDEN_FEATURES ?? ""}`.split(",").map((f) => f.trim().toLowerCase()).filter(Boolean),
);

export const isFeatureHidden = (feature: PortalFeature) => hidden.has(feature);
